import { render } from "./GridTable.vue?vue&type=template&id=1ce0c734&scoped=true&ts=true"
import script from "./gridTableHelper.ts?vue&type=script&lang=ts"
export * from "./gridTableHelper.ts?vue&type=script&lang=ts"

import "./GridTable.vue?vue&type=style&index=0&id=1ce0c734&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce0c734"]])

export default __exports__